<script setup lang="ts">
import type { CreditProduct } from '~/composables/credit';
import type { Component } from 'vue';

import { useCreditEvents, useCreditSimulator } from '~/composables/credit';

import IconMaterialSymbolsLightArrowForward from '~icons/material-symbols-light/arrow-forward';

import { creditSimulatorChoiceVariants } from '.';
import { CREDIT_PRODUCT_TABS } from '../content';
import CreditSimulatorConsortiumPanel from './CreditSimulatorConsortiumPanel.vue';
import CreditSimulatorFinancingPanel from './CreditSimulatorFinancingPanel.vue';
import CreditSimulatorHomeEquityPanel from './CreditSimulatorHomeEquityPanel.vue';

const PANELS: Record<CreditProduct, Component> = {
	financing: CreditSimulatorFinancingPanel,
	consortium: CreditSimulatorConsortiumPanel,
	homeEquity: CreditSimulatorHomeEquityPanel
};

const simulator = useCreditSimulator();
const creditEvents = useCreditEvents();
const product = computed(() => simulator.state.value.product);

const heading = useTemplateRef<HTMLElement>('heading');
defineExpose({ focusHeading: () => heading.value?.focus() });

function handleContinue() {
	creditEvents.trackConditions();
	simulator.next();
}
</script>

<template>
	<div class="flex flex-col gap-5.5">
		<div>
			<div
				ref="heading"
				tabindex="-1"
				class="text-[20px] font-medium outline-none"
			>
				Simule em 1 minuto
			</div>
			<div class="mt-1 text-[14px] text-[#A3A3A3]">
				Sem compromisso e sem consultar seu CPF nesta etapa.
			</div>
		</div>
		<div
			role="tablist"
			aria-label="Produto"
			class="grid grid-cols-3 gap-1.5 rounded-xs bg-[#1F1F1F] p-1.5"
		>
			<button
				v-for="tab in CREDIT_PRODUCT_TABS"
				:key="tab.product"
				type="button"
				role="tab"
				:aria-selected="tab.product === product"
				:class="
					creditSimulatorChoiceVariants({
						kind: 'tab',
						selected: tab.product === product
					})
				"
				@click="simulator.selectProduct(tab.product)"
			>
				{{ tab.label }}
			</button>
		</div>

		<component :is="PANELS[product]" />

		<button
			type="button"
			class="flex min-h-14 cursor-pointer items-center justify-center gap-2.5 rounded-xs border-none bg-beige text-[17px] font-medium text-black"
			@click="handleContinue"
		>
			Quero receber propostas
			<IconMaterialSymbolsLightArrowForward
				class="size-[18px]"
				aria-hidden="true"
			/>
		</button>
	</div>
</template>
